// extracted by mini-css-extract-plugin
export default {"enter":"Overlay_enter__vBZ9n","exit":"Overlay_exit__k81KM","wipe-in-right":"Overlay_wipe-in-right__-Zt50","wipe-out-left":"Overlay_wipe-out-left__jDRJA"};